import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { ChangeDetectionStrategy, AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDrawer, MatDrawerContent } from "@angular/material/sidenav";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from "@angular/router";
import { IFrameCommunicationService, MessageType } from "@irb-common/services";
import { interval, merge, Observable, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, filter, map, startWith, switchMap } from "rxjs/operators";
import { AppService } from "./app.service";
import { IEvent, IrbAppEvents, IrbClientsEvents, IrbCreatePortfolioEvents, IrbDialogsEvents, IrbEditorsEvents, IrbModelsEvents, IrbRebalanceEvents, IrbSettingsEvents } from "@irb-common/events";
import { SettingsDialogComponent } from "@irb/irb-settings/settings-dialog/settings-dialog.component";
import { CreatePortfolioDialogComponent } from "@irb/irb-create-portfolio/create-portfolio-dialog/create-portfolio-dialog.component";
import { PortfolioAccountAssignmentDialogComponent } from "@irb/irb-create-portfolio/portfolio-account-assignment-dialog/portfolio-account-assignment-dialog.component";
import { PortfolioImportHoldingsDialogComponent } from "@irb/irb-create-portfolio/portfolio-import-holdings-dialog/portfolio-import-holdings-dialog.component";
import { PortfolioCreatedDialogComponent } from "@irb/irb-create-portfolio/portfolio-created-dialog/portfolio-created-dialog.component";
import { DialogComponent } from "@irb-common/components/dialog/dialog.component";
import { MainMenuService } from "@irb-common/modules/main-menu/main-menu.service";
import { IrbCreateRebalanceComponent } from "@irb/irb-create-rebalance/irb-create-rebalance.component";
import { FooterDialogComponent } from "@irb-common/components/footer-dialog/footer-dialog.component";
import { AlertDialogComponent } from "@irb-common/components/alert-dialog/alert-dialog.component";
import { ConfirmationDialogComponent } from "@irb-common/components/confirmation-dialog/confirmation-dialog.component";
import { IrbFooterDialogEvents } from "@irb-common/components/footer/IrbFooterDialogEvents";
import { ImportCashSettingsDialogComponent } from "@irb/irb-clients/import-cash-settings-dialog/import-cash-settings-dialog.component";
import { ImportPortfolioNamesDialogComponent } from "@irb/irb-clients/import-portfolio-names-dialog/import-portfolio-names-dialog.component";
import { ImportPortfolioNamesResultDialogComponent } from "@irb/irb-clients/import-portfolio-names-result-dialog/import-portfolio-names-result-dialog.component";
import { ImportModelCategoryDialogComponent } from "@irb/irb-clients/import-model-category-dialog/import-model-category-dialog.component";
import { ImportModelCategoryResultDialogComponent } from "@irb/irb-clients/import-model-category-result-dialog/import-model-category-result-dialog.component";
import { ImportExternalAccountsDialogComponent } from "@irb/irb-clients/import-external-accounts-dialog/import-external-accounts-dialog.component";
import { ImportCashSettingsResultDialogComponent } from "@irb/irb-clients/import-cash-settings-result-dialog/import-cash-settings-result-dialog.component";
import { ImportExternalAccountsResultDialogComponent } from "@irb/irb-clients/import-external-accounts-result-dialog/import-external-accounts-result-dialog.component";
import { ImportExternalAccountsReadyDialogComponent } from "@irb/irb-clients/import-external-accounts-ready-dialog/import-external-accounts-ready-dialog.component";
import { ImportExternalAccountsSecuritiesDialogComponent } from "@irb/irb-clients/import-external-accounts-securities-dialog/import-external-accounts-securities-dialog.component";
import { ImportAccountsToPortfolioResultDialogComponent } from "@irb/irb-clients/import-accounts-to-portfolio-result-dialog/import-accounts-to-portfolio-result-dialog.component";
import { DeleteAssetCategorydialogComponent } from "@irb/irb-settings/settings-securities/delete-asset-category-dialog/delete-asset-category-dialog.component";
import { ImportAccountsToPortfolioComponent } from "@irb/irb-clients/import-accounts-to-portfolio/import-accounts-to-portfolio.component";
import { MessageService } from "primeng/api";
import { MorningstarCategoriesAutomaticMappingDialogComponent } from "@irb/irb-settings/settings-securities/Morningstar-categories-automatic-mapping-dialog/morningstar-categories-automatic-mapping-dialog.component";
import { AssignAccountsToPortfolioDialogComponent } from "@irb/irb-clients/assign-accounts-to-portfolio-dialog/assign-accounts-to-portfolio-dialog.component";
import { DeletePortfolioDialogComponent } from "@irb/irb-clients/delete-portfolio-dialog/delete-portfolio-dialog.component";
import { EditMultiplePortfoliosDialogComponent } from "./irb-clients/edit-multiple-portfolios-dialog/edit-multiple-portfolios-dialog.component";
import { ViewOptionComponent } from "./irb-models/view-option/view-option.component";
import { DeleteScheduledDialogComponent } from "./irb-rebalance/delete-scheduled-dialog/delete-scheduled-dialog.component";
import { ProcessScheduledDialogComponent } from "./irb-rebalance/process-scheduled-dialog/process-scheduled-dialog.component";
import { OwnerScheduledDialogComponent } from "./irb-rebalance/owner-scheduled-dialog/owner-scheduled-dialog.component";
import { ImportSecurityModelsDialogComponent } from "./irb-models/import-security-model-dialog/import-security-models-dialog.component";
import { ImportSecurityModelsResultDialogComponent } from "./irb-models/import-security-model-result-dialog/import-security-model-result-dialog.component";
import { ImportSecurityModelsUnrecognizedDialogComponent } from "./irb-models/import-security-model-unrecognized-dialog/import-security-model-unrecognized-dialog.component";
import { ImportSecurityModelsContainsDialogComponent } from "./irb-models/import-security-model-contains-dialog/import-security-model-contains-dialog.component";
import { RefreshScheduledDialogComponent } from "./irb-rebalance/refresh-scheduled-dialog/refresh-scheduled-dialog.component";
import { ImportBlendedModelsDialogComponent } from "./irb-models/import-blended-model-dialog/import-blended-models-dialog.component";
import { ImportBlendedModelsErrorDialogComponent } from "./irb-models/import-blended-model-error-dialog/import-blended-model-error-dialog.component";
import { ImportBlendedModelsResultDialogComponent } from "./irb-models/import-blended-model-result-dialog/import-blended-model-result-dialog.component";
import { CreateSecurityModelDialogComponent } from "./irb-models/create-security-model-dialog/create-security-model-dialog.component";
import { ImportExtraCashSettingsDialogComponent } from "./irb-editors/rebalance/rebalance-included-portfolio/import-extra-cash-settings-dialog/import-extra-cash-settings-dialog.component";
import { LossPrioritySettingsDialogComponent } from "./irb-editors/rebalance/rebalance-included-portfolio/loss-priority-settings-dialog/loss-priority-settings-dialog.component";
import { DeleteModelDialogComponent } from "./irb-models/delete-model-dialog/delete-model-dialog.component";
import { IAlertDialogData } from "@irb/app.model";
import { CreateBlendedModelDialogComponent } from "./irb-models/create-blended-model-dialog/create-blended-model-dialog.component";
import { CreateNewSecurityDialogComponent } from "@irb/irb-models/create-new-security-dialog/create-new-security-dialog.component";
import { DialogPrCostBasisComponent } from "@irb/irb-dialogs/dialog-pr-cost-basis/dialog-pr-cost-basis.component";
import { DialogPrExplanationComponent } from "@irb/irb-dialogs/dialog-pr-explanation/dialog-pr-explanation.component";
import { DialogPrAuditComponent } from "@irb/irb-dialogs/dialog-pr-audit/dialog-pr-audit.component";
import { DialogPrExportPdfComponent } from "@irb/irb-dialogs/dialog-pr-export-pdf/dialog-pr-export-pdf.component";
import { DialogPrExportPdfLegacyComponent } from "@irb/irb-dialogs/dialog-pr-export-pdf-legacy/dialog-pr-export-pdf-legacy.component";
import { DialogPrResubmitComponent } from "@irb/irb-dialogs/dialog-pr-resubmit/dialog-pr-resubmit.component";
import { MatDialogRef } from "@angular/material/dialog";
import { IrbOrdersEvents } from "@irb/irb-orders/IrbOrdersEvents";
import { CreateBlocksDialogComponent } from "@irb/irb-orders/create-blocks-dialog/create-blocks-dialog.component";
import { EditMultipleSecuritiesDialogComponent } from "./irb-models/edit-multiple-securities-dialog/edit-multiple-securities-dialog.component";
import { DeleteSecuritiesDialogComponent } from "./irb-models/delete-securities-dialog/delete-securities-dialog.component";
import { ImportEquivalentDialogComponent } from "./irb-models/import-equivalent-dialog/import-equivalent-dialog.component";
import { ImportEquivalentsResultDialogComponent } from "./irb-models/import-equivalents-result-dialog/import-equivalents-result-dialog.component";
import { OptionChainsDialog } from "./irb-editors/editor-coveredcall-rebalance/option-chains-dialog/option-chains-dialog.component";
import { ImportSecuritesCategoryDialogComponent } from "./irb-models/import-securites-category-dialog/import-securites-category-dialog.component";
import { ImportSecurityCategorySecuritiesDialogComponent } from "./irb-models/import-security-category-securities-dialog/import-security-category-securities-dialog.component";
import { ImportSecurityCategoryOverwriteDialogComponent } from "./irb-models/import-security-category-overwrite-dialog/import-security-category-overwrite-dialog.component";
import { AddMultipleSecuritiesDialogComponent } from "@irb/irb-models/add-multiple-securities-dialog/add-multiple-securities-dialog.component";
import { CreateSecuritiesDialogComponent } from "./irb-models/create-securities-dialog/create-securities-dialog.component";
import { DeleteSecuritiesSymbolDialogComponent } from "./irb-models/delete-securities-symbol-dialog/delete-securities-symbol-dialog.component";
import { DeleteSecuritiesErrorDialogComponent } from "./irb-models/delete-securities-error-dialog/delete-securities-error-dialog.component";
import { InverseAccountTypeDialogComponent } from "@irb/irb-editors/editor-security/inverse-account-type-dialog/inverse-account-type-dialog.component";
import { DeleteExternalAccountsDialogComponent } from "@irb/irb-clients/delete-external-accounts-dialog/delete-external-accounts-dialog.component";
import { ImportOrdersComponent } from "./irb-orders/order-blotter/import-orders/import-orders.component";
import { ImportOrdersResultDialogComponent } from "./irb-orders/order-blotter/import-orders-result-dialog/import-orders-result-dialog.component";
import { SelectMultiplePortfoliosDialogComponent } from "./irb-editors/rebalance/rebalance-included-portfolio/select-multiple-portfolios-dialog/select-multiple-portfolios-dialog.component";
import { DialogShowSecurityUsageWarningComponent } from "@irb/irb-dialogs/dialog-show-security-usage-warning/dialog-show-security-usage-warning.component";
import { environment } from "../environments/environment";
import { DialogDeleteComponentSecuritiesComponent } from "@irb/irb-dialogs/dialog-delete-component-securities/dialog-delete-component-securities.component";
import { CalltoactionService } from "@irb/irb-common/components/calltoaction/calltoaction.service";
import { HoverPanelService } from "@irb/irb-common/components/hover-panel/hover-panel.service";
import { ImportLossPrioritySettingsDialogComponent } from "./irb-editors/rebalance/rebalance-included-portfolio/import-loss-priority-settings-dialog/import-loss-priority-settings-dialog.component";
import { ImportLossPrioritySettingsErrorsDialogComponent } from "@irb/irb-editors/rebalance/rebalance-included-portfolio/import-loss-priority-settings-errors-dialog/import-loss-priority-settings-errors-dialog.component";
import { MmcMarketingDocumentsDialogComponent } from "@irb/irb-editors/editor-mmc-model/mmc-marketing-documents-dialog/mmc-marketing-documents-dialog.component";
import { MMCFooterDialogComponent } from "@irb-common/components/mmc-footer-dialog/mmc-footer-dialog.component";
import { MmcPaidModelAgreementDialogComponent } from "./irb-models/model-market-center/mmc-paid-model-agreement-dialog/mmc-paid-model-agreement-dialog.component";
import { MoveSecuritiesWarningsDialogComponent } from "@irb/irb-editors/editor-security/move-securities-warnings-dialog/move-securities-warnings-dialog.component";
import { MoveSecuritiesGridDataDialogComponent } from "@irb/irb-editors/editor-security/move-securities-grid-data-dialog/move-securities-grid-data-dialog.component";
import { MoveSecuritiesUsageReviewDialogComponent } from "@irb/irb-editors/editor-security/move-securities-usage-review-dialog/move-securities-usage-review-dialog.component";
import { ModelUsedInRebalanceDialogComponent } from "@irb/irb-editors/editor-portfolio-result/model-used-in-rebalance-dialog/model-used-in-rebalance-dialog.component";
import { DialogAnnouncementsComponent } from '@irb/irb-dialogs/dialog-announcements/dialog-announcements.component';
import { DialogPortfolioCustomLabelsModifyComponent } from '@irb/irb-dialogs/dialog-portfolio-custom-labels-modify/dialog-portfolio-custom-labels-modify.component';
import { DialogPortfolioMultieditViewComponent } from '@irb/irb-dialogs/dialog-portfolio-multiedit-view/dialog-portfolio-multiedit-view.component';
import { DialogAccountMultieditViewComponent } from '@irb/irb-dialogs/dialog-account-multiedit-view/dialog-account-multiedit-view.component';
import { IrbSettingsService } from "./irb-settings/irb-settings.service";
import { CreateReplaceSecurityDialogComponent } from "./irb-models/create-replace-security-dialog/create-replace-security-dialog.component";
import { CreateExternalAccountsDialogComponent } from "@irb/irb-clients/create-external-accounts-dialog/create-external-accounts-dialog.component";
import { CreateExternalAccountsCompleteDialogComponent } from "@irb/irb-clients/create-external-accounts-complete-dialog/create-external-accounts-complete-dialog.component";
import { DialogPrThresholdExceededComponent } from '@irb/irb-dialogs/dialog-pr-threshold-exceeded/dialog-pr-threshold-exceeded.component';
import { DialogQoeResultComponent } from '@irb/irb-dialogs/dialog-qoe-result/dialog-qoe-result.component';
import { UtilityService } from "@irb-common/services/utility.service";
import {
  EditExistingBlendedModel
} from "@irb/irb-models/models-new/edit-existing-blended-model/edit-existing-blended-model.component";
import {
  RebalanceTypeInfoDialogComponent
} from "@irb/irb-editors/rebalance/rebalance-type-info-dialog/rebalance-type-info-dialog.component";
import {
  EditMultiplePortfoliosAutomationDialogComponent
} from "@irb/irb-clients/edit-multiple-portfolios-automation-dialog/edit-multiple-portfolios-automation-dialog.component";
import {
  DialogFinmasonTrainSsoComponent
} from "@irb/irb-dialogs/dialog-finmason-train-sso/dialog-finmason-train-sso.component";
import {DialogWashSaleComponent} from "@irb/irb-dialogs/dialog-washsale-info/dialog-washsale-info.component";
import {ComViewAssetClassesDialogComponent} from'@irb/irb-settings/settings-securities/com-view-asset-classes-dialog/com-view-asset-classes-dialog.component';
import {
  ImportMmcModelsDialogFinishComponent
} from "@irb/irb-models/model-market-center/import-mmc-models-dialog-finish/import-mmc-models-dialog-finish.component";
import {DialogSyntaxSsoComponent} from "@irb/irb-dialogs/dialog-syntax-sso/dialog-syntax-sso.component";

@Component({ standalone: false,
  selector: "dux-app",
  styleUrls: ["./app.component.scss"],
  templateUrl: "./app.component.html",
  changeDetection: ChangeDetectionStrategy.Eager
})
export class AppComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(MatDrawerContent, { read: ElementRef }) drawerContent: ElementRef<HTMLElement>;
  @ViewChild(MatDrawer) drawer: MatDrawer;
  @ViewChild("dialog") dialog: DialogComponent;

  readonly backdropVisible$: Observable<boolean>;
  readonly progressVisible$: Observable<boolean>;
  userdata: any;
  menuconfigData: any;
  loadFooter: boolean;
  homeBckgCls: boolean = false;
  appUrl: string;
  
  @ViewChild("overlayComponent") private overlay: any;
  private sidebarMediaQuerySubscription: Subscription;
  private sidebarBreakpoint = [Breakpoints.Large, Breakpoints.XLarge];
  private eventSubscription: Subscription;
  private timeInterval:Subscription

  constructor(private readonly router: Router, 
    private readonly breakpointObserver: BreakpointObserver, 
    private readonly iframeCommunicationService: IFrameCommunicationService, 
    private as: AppService, 
    private mainMenuService: MainMenuService, 
    private messageService: MessageService,
    private ctas: CalltoactionService, 
    private hps: HoverPanelService, 
    public iss: IrbSettingsService,
    private util: UtilityService) {
      this.backdropVisible$ = this.toggleBackdropVisibility();
      this.progressVisible$ = this.toggleProgressVisibility();
      this.scrollDrawerContentOnIframeNavigation();

      this.eventSubscription = this.as.getEvents().subscribe((s) => {
        this.processEvent(s);
      });

      this.checkWaitForConfig();
      this.addWalkMeScript();
      this.addAnalyticsScript();
      this.appUrl = router.url;
  }


  ngOnInit(): void {
    if (this.router.url === "/home") {
      this.homeBckgCls = true;
    }

    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.homeBckgCls = e.url === "/home";
        
        if (this.homeBckgCls) {
          this.syncConfig();
        }

        this.loadFooter = (e.url === '/initial-setup') ? false : true;
      } else if (e instanceof NavigationStart) {
        const url = e.url.split("?")[0];

        if(url !== "/") {
          window.sessionStorage.setItem("IRB_PATH", url);
        }        
      }
    });

    const bc = new BroadcastChannel('IREBAL_CHANNEL');

    bc.onmessage = event => {
      if(event.origin === window.location.origin) {
        if(event.data === "IREBAL_LOG_OUT") {
          this.as.logOut();
        }
      }
    }
  }

  ngAfterViewInit() {
    this.drawerContent.nativeElement.addEventListener("scroll", () => {
      this.ctas.redraw();
      this.hps.redraw();
    });

    setTimeout(() => {
      this.sidebarMediaQuerySubscription = this.breakpointObserver.observe(this.sidebarBreakpoint).subscribe((breakpointState) => {
        // setTimeout() is a workaround for issue - https://github.com/angular/material2/issues/12479
        setTimeout(() => this.drawer.toggle(breakpointState.matches));
      });
    });
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
    this.sidebarMediaQuerySubscription.unsubscribe();
    this.iframeCommunicationService.destroy();
  }

  checkWaitForConfig() {
    const waitForData = setInterval(() => {
      const config = this.as.getItem("IRB_APP_CONFIG");
      if (config) {
        this.userdata = config;
        this.menuconfigData = this.mainMenuService.getMenuData(this.userdata);
        (<any>window).appEnvironment = this.userdata.appEnvironment;
        (<any>window).irebalUserId = this.userdata.userID;
        (<any>window).session_user = this.userdata.userID;
        clearInterval(waitForData);
      }
    }, 0);
  }

  syncConfig() {
    const waitForData = setInterval(() => {
      const config = this.as.getItem("IRB_APP_CONFIG");
      if (config) {
        this.userdata = config;
        this.menuconfigData = this.mainMenuService.getMenuData(this.userdata);
        clearInterval(waitForData);
      }
    }, 0);
  }

  processEvent(event: IEvent) {
    switch (event.type) {
      case IrbSettingsEvents.SHOW:
        this.showGlobalSettings(event.data);
        break;
      case IrbSettingsEvents.SHOW_WASH_SALE_INFO:
          this.showWashSaleInfo(event.data);
          break;
      case IrbCreatePortfolioEvents.SHOW_CREATE_PORTFOLIO:
        this.showCreatePortfolio(event.data);
        break;
      case IrbCreatePortfolioEvents.SHOW_PORTFOLIO_ACCOUNT_ASSIGNMENT:
        this.showPortfolioAccountAssignmentDialog(event.data);
        break;
      case IrbCreatePortfolioEvents.SHOW_PORTFOLIO_IMPORT_HOLDINGS:
        this.showPortfolioImportHoldingsDialog(event.data);
        break;
      case IrbCreatePortfolioEvents.SHOW_PORTFOLIO_CREATED:
        this.showPortfolioCreatedDialog(event.data);
        break;
      case IrbAppEvents.SHOW_WAIT:
        this.overlay.showWait();
        break;
      case IrbAppEvents.HIDE_WAIT:
        this.overlay.hideWait();
        break;
      case "createRebalance":
        this.showCreateRebalanceDialog(event.data);
        break;
      case IrbSettingsEvents.SHOW_DELETE_ASSET_CATEGORY:
        this.showDeleteAssetCategoryDialog(event.data);
        break;
      case "MorningstarCategoriesAutomaticMapping":
        this.MorningstarCategoriesAutomaticMapping(event.data);
        break;
      case IrbFooterDialogEvents.SHOW_FOOTER_DIALOG:
        this.showFooterDialog();
        break;
      case IrbFooterDialogEvents.SHOW_MMC_FOOTER_DIALOG:
        this.showMMCFooterDialog();
        break;
      case IrbClientsEvents.SHOW_IMPORT_CASH_SETTINGS:
        this.showImportCashSettingsDialog();
        break;
      case IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS:
        this.showImportExternalAccountsDialog();
        break;
      case IrbClientsEvents.SHOW_CREATE_EXTERNAL_ACCOUNTS:
      this.showCreateExternalAccountsDialog();
      break;
      case IrbClientsEvents.SHOW_CREATE_EXTERNAL_ACCOUNTS_COMPLETE:
      this.showCreateExternalAccountsCompleteDialog(event.data);
      break;
      case IrbClientsEvents.SHOW_IMPORT_CASH_SETTINGS_RESULT:
        this.showImportCashSettingsResultDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS_RESULT:
        this.showImportExternalAccountsResultDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS_READY:
        this.showImportExternalAccountsReadyDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS_SECURITIES:
        this.showImportExternalAccountsSecuritiesDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_IMPORT_ACCOUNTS_TO_PORTFOLIO_RESULT:
        this.showImportAccountsToPortfolioResultDialog(event.data);
        break;
      case IrbAppEvents.SHOW_ALERT:
        this.showAlertDialog(event.data);
        break;
      case IrbAppEvents.SHOW_CONFIRMATION:
        this.showConfirmationDialog(event.data);
        break;
      case IrbAppEvents.SHOW_TOAST:
        this.showToast(event.data);
        break;
      case IrbAppEvents.HIDE_TOAST:
        this.hideToast();
        break;
      case IrbClientsEvents.SHOW_IMPORT_ACCOUNTS_TO_PORTFOLIO:
        this.showImportAccountsToPortfolioDialog();
        break;
      case IrbClientsEvents.SHOW_ASSIGN_ACCOUNTS_TO_PORTFOLIO:
        this.showAssignAccountsToPortfolioDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_THRESHOLD_EXCEEDED_DIALOG:
        this.showDialogPrThresholdExceededComponent(event.data);
        break;
      case IrbClientsEvents.SHOW_DELETE_PORTFOLIO_DIALOG:
        this.showDeletePortfolioDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_EDIT_MULTIPLE_PORTFOLIO_DIALOG:
        this.showEditMultiplePortfolioDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_EDIT_MULTIPLE_PORTFOLIO_AUTOMATION_DIALOG:
        this.showEditMultiplePortfolioAutomationDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_VIEW_SECURITY_MODEL:
        this.viewOptionDialog(event.data);
        break;
      case IrbRebalanceEvents.SHOW_DELETE_SCHEDULED_DIALOG:
        this.showDeleteSchdeduledDialog(event.data);
        break;
      case IrbRebalanceEvents.SHOW_PROCESS_SCHEDULED_DIALOG:
        this.showProcessSchdeduledDialog(event.data);
        break;
      case IrbRebalanceEvents.SHOW_CHANGE_OWNER_SCHEDULED_DIALOG:
        this.chageOwnerSchdeduledDialog(event.data);
        break;
      case IrbRebalanceEvents.SHOW_REFRESH_SCHEDULED_DIALOG:
        this.showRefreshSchdeduledDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS:
        this.showImportSecurityModelsDialog();
        break;
      case IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_RESULT:
        this.showImportSecurityModelsResultDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_UNRECOGNIZED:
        this.showImportSecurityModelsUnrecognizedDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_SECURITY_MODELS_CONTAINS:
        this.showImportSecurityModelsContainsDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_BLENDED_MODELS:
        this.showImportBlendedModelsDialog();
        break;
      case IrbModelsEvents.SHOW_IMPORT_BLENDED_MODELS_ERROR:
        this.showImportBlendedModelsErrorDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_BLENDED_MODELS_RESULT:
        this.showImportBlendedModelsResultDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_CREATE_SECURITY_MODELS:
        this.showCreateSecurityModelsDialog();
        break;
      case IrbEditorsEvents.SHOW_IMPORT_EXTRA_CASH_SETTINGS:
        this.showImportExtraCashSettingsDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_LOSS_PRIORITY_SETTINGS_DIALOG:
        this.showLossPriorityDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_INVERSE_ACCOUNT_TYPE_DIALOG:
        this.showInverseAccountTypeDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_OPTION_CHAINS_DIALOG:
        this.showOptionChainsDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_DELETE_MODEL_DIALOG:
        this.showDeleteModalDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_REPLACE_SECURITY_MODELS:
        this.showCreateReplaceSecurityModalDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_CREATE_BLENDED_MODELS:
        this.showCreateBlendedModelsDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_CREATE_NEW_SECURITY:
        this.showCreateNewSecurityDialog();
        break;
      case IrbDialogsEvents.SHOW_PR_EXPLANATION:
        this.showPrExplanationDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_PR_COST_BASIS:
        this.showPrCostBasisDialog(event.data)
          .afterClosed()
          .subscribe(() => this.as.fireEvent(IrbDialogsEvents.PR_COST_BASIS_CLOSED));
        break;
      case IrbDialogsEvents.SHOW_PR_AUDIT:
        this.showPrAuditDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_PR_EXPORT_PDF:
        this.showPrExportPDFDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_PR_EXPORT_PDF_LEGACY:
        this.showPrExportPDFLegacyDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_PR_RESUBMIT:
        this.showPrResubmitDialog(event.data);
        break;
      case IrbOrdersEvents.SHOW_CREATE_BLOCKS_DIALOG:
        this.showCreateBlocksDialog(event.data);
        break;
      case IrbOrdersEvents.SHOW_UNBLOCK_ORDERS_DIALOG:
        this.showUnblockOrdersDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_EDIT_MULTIPLE_SECURITY_DIALOG:
        this.showEditMultipleSecuritiesDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_DELETE_SECURITIES_DIALOG:
        this.showDeleteSecuritiesDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY:
        this.showImportSecurityAndCategoryDialog();
        break;
      case IrbModelsEvents.SHOW_IMPORT_EQUIVALENTS:
        this.showImportEquivalentsDialog();
        break;
      case IrbModelsEvents.SHOW_IMPORT_EQUIVALENTS_ERROR:
        this.showImportEquivalentsErrorDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_SECURITIES:
        this.showImportSecurityCategorySecuritiesDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_SECURITY_CATEGORY_OVERWRITE:
        this.showImportSecurtiyCategoryOerwriteDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_MASTER_MULTIPLE_SECURITY:
        this.showMasterMultipleSecuritiesDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_CREATE_SECURITIES:
        this.showCreateSecurities(event.data);
        break;
      case IrbModelsEvents.SHOW_DELETE_SECURITIES_ERROR_DIALOG:
        this.showDeleteSecuritiesErrorDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_DELETE_SECURITIES_SYMBOL_DIALOG:
        this.showDeleteSecuritiesSymbolDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_DELETE_EXTERNAL_ACCOUNTS_DIALOG:
        this.showDeleteExternalAccountsDialog(event.data);
        break;
      case IrbOrdersEvents.SHOW_IMPORT_ORDERS:
        this.showImportOrdersDialog(event.data);
        break;
      case IrbOrdersEvents.SHOW_IMPORT_ORDERS_RESULT:
        this.showImportOrdersResultDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_MULTIPLE_PORTFOLIO_SELECTION_DIALOG:
        this.showMasterMultiplePortfoliosDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_SECURITY_USAGE_WARNING:
        this.showSecrityUsageWarning(event.data);
        break;
      case IrbDialogsEvents.SHOW_DELETE_COMPONENT_SECURITIES_DIALOG:
        this.showDeleteComponentSecritiesDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_DIALOG:
        this.showImportLossPrioritySettingsDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_IMPORT_LOSS_PRIORITY_SETTINGS_ERROR_DIALOG:
        this.showImportLossPrioritySettingsErrorDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_MMC_MARKETING_DOCUMENTS:
        this.showMmcMarketingDocumentsDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_MMC_PAID_AGREEMENT:
        this.showMMCPaidAgreemrntDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_MOVE_SECURITIES_WARNINGS_DIALOG:
        this.showMoveSecuritiesWarningsDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_MOVE_SECURITIES_GRID_DATA_DIALOG:
        this.showMoveSecuritiesGridDataDialog(event.data);
        break;
      case IrbEditorsEvents.SHOW_MOVE_SECURITIES_USAGE_REVIEW_DIALOG:
        this.showMoveSecuritiesUsageReviewDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_MODEL_USED_IN_REBALANCE_DIALOG:
        this.showModelUsedInRebalanceDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_ANNOUNCEMENTS:
        this.showAnnouncementsDialog(event.data);
        break;
      case IrbSettingsEvents.SHOW_IMPORT_SEC_JOB_STATUS:
        this.showImportSecuritiesAlert(false);
        break;
      case IrbClientsEvents.SHOW_IMPORT_PORTFOLIO_NAMES:
        this.showImportPortfolioNames();
        break;
      case IrbClientsEvents.SHOW_IMPORT_PORTFOLIO_NAMES_RESULT:
        this.showImportPortfolioNamesResultDialog(event.data);
        break;
      case IrbClientsEvents.SHOW_IMPORT_MODEL_CATEGORY:
        this.showImportModelCategory();
        break;
      case IrbClientsEvents.SHOW_IMPORT_MODEL_CATEGORY_RESULT:
        this.showImportModelCategoryResultDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_ADD_TO_EXISTING_BLENDED_MODELS:
        this.showEditExistingBlendedModel(event.data);
        break;
      case IrbEditorsEvents.SHOW_REBALANCE_TYPE_INFO_DIALOG:
        this.showRebalanceTypeInfoDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_FINMASON_TRAIN_SSO:
        this.showFinmasonTrainSsoDialogComponent(event.data);
        break;
      case IrbDialogsEvents.SHOW_PORTFOLIO_CUSTOM_LABELS_MODIFY:
        this.showPortfolioCustomLabelsModifyDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_PORTFOLIO_MULTIEDIT_VIEW:
        this.showPortfolioMultieditViewDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_ACCOUNT_MULTIEDIT_VIEW:
        this.showAccountMultieditViewDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_VIEW_ASSET_CLASSES_DIALOG:
        this.showViewAssetClassesDialog(event.data);
        break;
      case IrbDialogsEvents.SHOW_QOE_RESULT_DIALOG:
        this.showQoeResultDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_IMPORT_MMC_MODELS_FINISH:
        this.showImportMMCModelsFinishDialog(event.data);
        break;
      case IrbModelsEvents.SHOW_CREATE_SYNTAX_DIALOG:
        this.showCreateSyntaxDialog();
        break;
    }
  }

  showRebalanceTypeInfoDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "800px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(RebalanceTypeInfoDialogComponent, config);
  }

  showAnnouncementsDialog(data?: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "650px";
    config.minHeight = "auto";
    config.data = data;
    this.dialog.open(DialogAnnouncementsComponent, config);
  }

  showPortfolioCustomLabelsModifyDialog(data?: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "800px";
    config.minHeight = "auto";
    config.data = data;
    this.dialog.open(DialogPortfolioCustomLabelsModifyComponent, config);
  }

  showPortfolioMultieditViewDialog(data?: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "800px";
    config.minHeight = "auto";
    config.data = data;
    this.dialog.open(DialogPortfolioMultieditViewComponent, config);
  }

  showAccountMultieditViewDialog(data?: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "800px";
    config.minHeight = "auto";
    config.data = data;
    this.dialog.open(DialogAccountMultieditViewComponent, config);
  }

  showViewAssetClassesDialog(data?: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "600px";
    config.minHeight = "auto";
    config.data = (data) ? data : null;
    this.dialog.open(ComViewAssetClassesDialogComponent, config);
  }

  showQoeResultDialog(data?: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(DialogQoeResultComponent, config);
  }

  showImportLossPrioritySettingsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    config.data = data;
    this.dialog.open(ImportLossPrioritySettingsDialogComponent, config);
  }

  showImportLossPrioritySettingsErrorDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    config.data = data;
    this.dialog.open(ImportLossPrioritySettingsErrorsDialogComponent, config);
  }

  viewOptionDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "800px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(ViewOptionComponent, config);
  }

  showGlobalSettings(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "1140px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(SettingsDialogComponent, config);
  }

  showCreatePortfolio(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.width = "500px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(CreatePortfolioDialogComponent, config);
  }

  showPortfolioAccountAssignmentDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "600px";
    config.height = "auto";
    config.width = "850px";
    config.data = data;
    this.dialog.open(PortfolioAccountAssignmentDialogComponent, config);
  }

  showPortfolioImportHoldingsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.width = "801px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(PortfolioImportHoldingsDialogComponent, config);
  }

  showPortfolioCreatedDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.width = "500px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(PortfolioCreatedDialogComponent, config);
  }

  showFooterDialog() {
    const config = this.dialog.getDefaultConfig();
    config.width = "800px";
    config.height = "auto";
    this.dialog.open(FooterDialogComponent, config);
  }

  showMMCFooterDialog() {
    const config = this.dialog.getDefaultConfig();
    config.width = "780px";
    config.height = "auto";
    this.dialog.open(MMCFooterDialogComponent, config);
  }

  showAlertDialog(data: IAlertDialogData) {
    const config = this.dialog.getDefaultConfig();
    config.width = data.dWidth ? data.dWidth + "px" : "500px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(AlertDialogComponent, config);
  }

  showConfirmationDialog(data: IAlertDialogData) {
    const config = this.dialog.getDefaultConfig();
    config.width = data.dWidth ? data.dWidth + "px" : "500px";
    config.height = "auto";
    config.data = data;
    config.restoreFocus = false;
    this.dialog.open(ConfirmationDialogComponent, config);
  }

  showCreateRebalanceDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "500px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(IrbCreateRebalanceComponent, config);
  }

  showDeleteAssetCategoryDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "400px";
    config.height = "auto";
    config.width = "600px";
    config.data = data;
    this.dialog.open(DeleteAssetCategorydialogComponent, config);
  }

  MorningstarCategoriesAutomaticMapping(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "200px";
    config.height = "auto";
    config.width = "600px";
    config.data = data;
    this.dialog.open(MorningstarCategoriesAutomaticMappingDialogComponent, config);
  }

  showImportCashSettingsDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportCashSettingsDialogComponent, config);
  }

  showImportPortfolioNames() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportPortfolioNamesDialogComponent, config);
  }

  showImportModelCategory() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportModelCategoryDialogComponent, config);
  }

  showImportExternalAccountsDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportExternalAccountsDialogComponent, config);
  }

  showCreateExternalAccountsDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "200px";
    config.height = "auto";
    config.width = "1074px";
    this.dialog.open(CreateExternalAccountsDialogComponent, config);
  }

  showCreateExternalAccountsCompleteDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "200px";
    config.height = "auto";
    config.width = "510px";
    config.data = data;
    this.dialog.open(CreateExternalAccountsCompleteDialogComponent, config);
  }

  showImportAccountsToPortfolioDialog() {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportAccountsToPortfolioComponent, config);
  }

  showAssignAccountsToPortfolioDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.width = "625px";
    config.height = "auto";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(AssignAccountsToPortfolioDialogComponent, config);
  }

  showDialogPrThresholdExceededComponent(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.width = "725px";
    config.height = "auto";
    config.data = data;
    this.dialog.open(DialogPrThresholdExceededComponent, config);
  }

  showDeletePortfolioDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(DeletePortfolioDialogComponent, config);
  }

  showEditMultiplePortfolioDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(EditMultiplePortfoliosDialogComponent, config);
  }
  showEditMultiplePortfolioAutomationDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(EditMultiplePortfoliosAutomationDialogComponent, config);
  }

  showImportCashSettingsResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportCashSettingsResultDialogComponent, config);
  }

  showImportPortfolioNamesResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportPortfolioNamesResultDialogComponent, config);
  }

  showImportModelCategoryResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportModelCategoryResultDialogComponent, config);
  }

  showImportExternalAccountsResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportExternalAccountsResultDialogComponent, config);
  }

  showImportExternalAccountsReadyDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportExternalAccountsReadyDialogComponent, config);
  }

  showImportExternalAccountsSecuritiesDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportExternalAccountsSecuritiesDialogComponent, config);
  }

  showImportAccountsToPortfolioResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportAccountsToPortfolioResultDialogComponent, config);
  }

  showDeleteSchdeduledDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(DeleteScheduledDialogComponent, config);
  }

  showProcessSchdeduledDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "700px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(ProcessScheduledDialogComponent, config);
  }

  chageOwnerSchdeduledDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(OwnerScheduledDialogComponent, config);
  }

  showRefreshSchdeduledDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(RefreshScheduledDialogComponent, config);
  }

  showToast(data: any) {
    if (data.severity && data.severity === 'success') {
      data.life = data.life ? data.life : 1500;
    }
    this.messageService.add(data);
  }

  hideToast() {
    this.messageService.clear();
  }

  showImportSecurityModelsDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportSecurityModelsDialogComponent, config);
  }

  showImportSecurityModelsResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportSecurityModelsResultDialogComponent, config);
  }

  showImportSecurityModelsUnrecognizedDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportSecurityModelsUnrecognizedDialogComponent, config);
  }

  showImportSecurityModelsContainsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportSecurityModelsContainsDialogComponent, config);
  }

  showImportBlendedModelsDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportBlendedModelsDialogComponent, config);
  }

  showImportBlendedModelsErrorDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportBlendedModelsErrorDialogComponent, config);
  }

  showImportBlendedModelsResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportBlendedModelsResultDialogComponent, config);
  }

  showCreateSecurityModelsDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(CreateSecurityModelDialogComponent, config);
  }

  showImportExtraCashSettingsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    config.data = data;
    this.dialog.open(ImportExtraCashSettingsDialogComponent, config);
  }

  showLossPriorityDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "700px";
    config.data = data;
    this.dialog.open(LossPrioritySettingsDialogComponent, config);
  }

  showDeleteModalDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(DeleteModelDialogComponent, config);
  }

  showCreateReplaceSecurityModalDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(CreateReplaceSecurityDialogComponent, config);
  }

  showCreateNewSecurityDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(CreateNewSecurityDialogComponent, config);
  }

  showPrExplanationDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "800px";
    config.data = data;
    this.dialog.open(DialogPrExplanationComponent, config);
  }

  showPrCostBasisDialog(data: any): MatDialogRef<any> {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    return this.dialog.open(DialogPrCostBasisComponent, config);
  }

  showPrAuditDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "850px";
    config.data = data;
    this.dialog.open(DialogPrAuditComponent, config);
  }

  showPrExportPDFDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(DialogPrExportPdfComponent, config);
  }

  showPrExportPDFLegacyDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(DialogPrExportPdfLegacyComponent, config);
  }

  showPrResubmitDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(DialogPrResubmitComponent, config);
  }

  showDeleteSecuritiesDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(DeleteSecuritiesDialogComponent, config);
  }

  showOptionChainsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "200px";
    config.height = "auto";
    config.width = "960px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(OptionChainsDialog, config);
  }

  showCreateBlendedModelsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    config.data = data;
    this.dialog.open(CreateBlendedModelDialogComponent, config);
  }

  showCreateBlocksDialog(params: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "200px";
    config.height = "auto";
    config.width = "695px";
    const dialogRef = this.dialog.open(CreateBlocksDialogComponent, config);
    dialogRef.componentInstance.inventoryComponentRef = params.inventoryComponent;
  }

  showUnblockOrdersDialog(params: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "300px";
    config.height = "auto";
    config.width = "695px";
    const dialogRef = this.dialog.open(CreateBlocksDialogComponent, config);
    dialogRef.componentInstance.inventoryComponentRef = params.inventoryComponent;
    dialogRef.componentInstance.step = "show-unblock-orders";
  }

  showEditMultipleSecuritiesDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(EditMultipleSecuritiesDialogComponent, config);
  }

  showImportSecurityAndCategoryDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportSecuritesCategoryDialogComponent, config);
  }

  showImportEquivalentsDialog() {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    this.dialog.open(ImportEquivalentDialogComponent, config);
  }

  showImportEquivalentsErrorDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportEquivalentsResultDialogComponent, config);
  }

  showImportSecurityCategorySecuritiesDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "300px";
    config.height = "auto";
    config.width = "750px";
    config.data = data;
    this.dialog.open(ImportSecurityCategorySecuritiesDialogComponent, config);
  }

  showImportSecurtiyCategoryOerwriteDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportSecurityCategoryOverwriteDialogComponent, config);
  }

  showMasterMultipleSecuritiesDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "600px";
    config.height = "auto";
    config.width = "1200px";
    config.data = data;
    this.dialog.open(AddMultipleSecuritiesDialogComponent, config);
  }

  showCreateSecurities(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "200px";
    config.height = "auto";
    config.width = "960px";
    config.data = data;
    this.dialog.open(CreateSecuritiesDialogComponent, config);
  }

  showDeleteSecuritiesErrorDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(DeleteSecuritiesErrorDialogComponent, config);
  }

  showDeleteSecuritiesSymbolDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(DeleteSecuritiesSymbolDialogComponent, config);
  }

  showInverseAccountTypeDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(InverseAccountTypeDialogComponent, config);
  }

  showDeleteExternalAccountsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "850px";
    config.data = data;
    config.panelClass = "irb";
    this.dialog.open(DeleteExternalAccountsDialogComponent, config);
  }

  showImportOrdersDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "550px";
    config.data = data;
    this.dialog.open(ImportOrdersComponent, config);
  }

  showImportOrdersResultDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ImportOrdersResultDialogComponent, config);
  }

  showMasterMultiplePortfoliosDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "600px";
    config.height = "auto";
    config.width = "1200px";
    config.data = data;
    this.dialog.open(SelectMultiplePortfoliosDialogComponent, config);
  }

  showSecrityUsageWarning(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "600px";
    config.data = data;
    this.dialog.open(DialogShowSecurityUsageWarningComponent, config);
  }

  showDeleteComponentSecritiesDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "600px";
    config.data = data;
    this.dialog.open(DialogDeleteComponentSecuritiesComponent, config);
  }
  showMmcMarketingDocumentsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "250px";
    config.height = "auto";
    config.width = "900px";
    config.data = data;
    this.dialog.open(MmcMarketingDocumentsDialogComponent, config);
  }

  showMMCPaidAgreemrntDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "650px";
    config.width = "740px";
    config.data = data;
    this.dialog.open(MmcPaidModelAgreementDialogComponent, config);
  }
  showMoveSecuritiesWarningsDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "500px";
    config.data = data;
    this.dialog.open(MoveSecuritiesWarningsDialogComponent, config);
  }
  showMoveSecuritiesGridDataDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "600px";
    config.data = data;
    this.dialog.open(MoveSecuritiesGridDataDialogComponent, config);
  }
  showMoveSecuritiesUsageReviewDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "600px";
    config.data = data;
    this.dialog.open(MoveSecuritiesUsageReviewDialogComponent, config);
  }
  showModelUsedInRebalanceDialog(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = data;
    this.dialog.open(ModelUsedInRebalanceDialogComponent, config);
  }

  showEditExistingBlendedModel(eventData: any) {
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "535px";
    config.data = eventData;
    this.dialog.open(EditExistingBlendedModel, config);
  }

  showWashSaleInfo(data?: any) {
    const config = this.dialog.getDefaultConfig();
    config.width = "650px";
    config.minHeight = "auto";
    config.data = data;
    this.dialog.open(DialogWashSaleComponent, config);
  }

  private toggleBackdropVisibility(): Observable<boolean> {
    return merge(this.iframeCommunicationService.on(MessageType.OverlayClose), this.iframeCommunicationService.on(MessageType.OverlayOpen)).pipe(
      map((message) => message.type === MessageType.OverlayOpen),
      startWith(false)
    );
  }

  private toggleProgressVisibility(): Observable<boolean> {
    return this.router.events.pipe(
      filter((event) => event instanceof NavigationStart || event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel),
      debounceTime(100),
      map((event) => event instanceof NavigationStart),
      distinctUntilChanged()
    );
  }

  private scrollDrawerContentOnIframeNavigation(): void {
    this.iframeCommunicationService.on(MessageType.BeforeUnload).subscribe(() => {
      if (this.drawerContent) {
        this.drawerContent.nativeElement.scrollTop = 0;
      }
    });
  }

  private addWalkMeScript() {
    if (environment.walkMeEnabled) {
      const walkme = document.createElement("script");
      walkme.type = "text/javascript";
      walkme.async = true;
      walkme.src = (this.util.getEnv() === "PROD") ? environment.walkMeSourceProd : environment.walkMeSource;
      const script = document.getElementsByTagName("script")[0];
      script.parentNode.insertBefore(walkme, script);
      (window as any)._walkmeConfig = { smartLoad: true };
    }
  }

  private addAnalyticsScript() {
    const env_id = (this.util.getEnv() === "PROD") ? 'PROD' : 'DEV';
    const s1 = document.createElement("script");
    s1.type = "text/javascript";
    s1.innerHTML = `
      try {
        window.tms = window.tms || {};
        window.tms.queue = window.tms.queue || [];
        window.tms.preventdefault = true;
        window.tms.trackPage = window.tms.trackPage || function () { tms.queue.push({ func: 'trackPage', args: arguments }); };
        window.tms.init = window.tms.init || function () { tms.queue.push({ func: 'init', args: arguments }); };
        tms.data = {
            env_id:                '${env_id}',                   
            loginstatus:           true,
            prelogin_category:     '/si2/irebal',
            postlogin_category:    '/si2/irebal',
            dc_src:                '2530996',
            sc_server:             'metric.schwabinstitutional.com',
            sc_serversecure:       'smetric.schwabinstitutional.com',
            report_suite_set:  {
                DEV:    'cschwabadvisorservicesuat',
                ACPT:   'cschwabadvisorservicesuat',
                PROD:   'cschwabadvisorservicesprod'
            }
        }
      } catch (e) { console.error('Unable to initialize tms.'); }`;
    
    const s2 = document.createElement("script");
    s2.type = "text/javascript";
    s2.async = true;
    s2.src = "//tags.tiqcdn.com/utag/schwab/global-public/prod/utag.js";

    const script = document.getElementsByTagName("script")[0];
    script.parentNode.insertBefore(s1, script);
    script.parentNode.insertBefore(s2, script);
  }
    
  showImportSecuritiesAlert(offTimer:boolean){
      this.timeInterval = interval(5000).pipe(
        startWith(0),
        switchMap(() => this.iss.checkImportSecuritiesJobStatus())).subscribe((data: any) => {
        if (data.responseUtilityMap.isJobCompleted === "FAILED") {
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            key:'irb-import-sec-job-message',
            severity: 'error',
            summary: 'Import Failed',
            detail: "Please contact the support team at...",
            sticky:true
        });
        this.timeInterval.unsubscribe();
        } else if (data.responseUtilityMap.isJobCompleted === "COMPLETED"){
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
              key: 'irb-import-sec-job-message',
              severity: 'success',
              summary: 'Import Complete',
              detail: "Your securities inventory has been updated",
              sticky:true
            });
            this.timeInterval.unsubscribe();
        }else if (data.responseUtilityMap.isJobCompleted === "NO_REQUEST" && offTimer){
          //No need to show any toast message.
          this.timeInterval.unsubscribe();
        }
      });
  }

  onCloseImportSecuritiesAlert(){
    this.iss.acknowledgeImportSecJob().subscribe();
  }

  showFinmasonTrainSsoDialogComponent(data: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "850px";
    config.data = data;
    this.dialog.open(DialogFinmasonTrainSsoComponent, config);
  }

  showImportMMCModelsFinishDialog(eventData: any) {
    const config = this.dialog.getDefaultConfig();
    config.restoreFocus = false;
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    config.data = eventData;
    this.dialog.open(ImportMmcModelsDialogFinishComponent, config);
  }

  showCreateSyntaxDialog(){
    const config = this.dialog.getDefaultConfig();
    config.minHeight = "100px";
    config.height = "auto";
    config.width = "650px";
    this.dialog.open(DialogSyntaxSsoComponent, config);
  }
}
